import { Box, Typography } from "@mui/material";
import { t } from "i18next";

const DashboardCard = ({ data, index, handleClickOnCard }) => {
  return (
    <Box
      sx={{
        border: "2px solid #ECEEF6",
        borderRadius: 5,
        paddingY: 4,
        paddingX: 1.5,
        backgroundColor: "text.white",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        boxShadow: "0px 20px 50px 0px #DCE0F980",
        cursor: "pointer",
        "&:hover": {
          borderWidth: "1px",
          borderColor: "primary.main",
        },
      }}
      onClick={() => handleClickOnCard(data, index)}
    >
      <Box>
        <img
          src={data?.icon}
          alt={"icon"}
          style={{
            width: 70,
            height: 70,
          }}
        />
      </Box>
      <Typography variant="h6" fontWeight={600} textTransform={"capitalize"}>
        {t(data?.title)}
      </Typography>
    </Box>
  );
};

export default DashboardCard;
